var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import { getRebornUrl } from '@/shared/utils/helpers';
let WhatsappEnrichmentIframeModal = class WhatsappEnrichmentIframeModal extends Vue {
    constructor() {
        super(...arguments);
        this.retryTimers = [];
    }
    get iframeSrc() {
        return `${getRebornUrl()}/solicitar-whatsapp`;
    }
    onLoad() {
        console.log('[IframeModal] @load disparado — iframe carregou:', this.iframeSrc);
        console.log('[IframeModal] infoSetId no route:', this.$route.params.infosetId);
        console.log('[IframeModal] token presente:', !!localStorage.getItem('auth_token_default'));
        console.log('[IframeModal] termsAccepted:', this.termsAccepted);
        this.clearRetryTimers();
        this.sendInit('onLoad imediato');
        this.retryTimers.push(setTimeout(() => this.sendInit('fallback 500ms'), 500));
        this.retryTimers.push(setTimeout(() => this.sendInit('fallback 2000ms'), 2000));
    }
    sendInit(origem) {
        const iframe = this.$refs.iframe;
        if (!iframe || !iframe.contentWindow) {
            console.warn('[IframeModal] sendInit(' +
                origem +
                '): iframe ref ou contentWindow é null');
            return;
        }
        const payload = {
            type: 'ENRICHMENT_INIT',
            infoSetId: this.$route.params.infosetId,
            token: localStorage.getItem('auth_token_default') || '',
            termsAccepted: this.termsAccepted,
        };
        console.log('[IframeModal] sendInit(' + origem + ') → postMessage:', payload);
        iframe.contentWindow.postMessage(payload, '*');
    }
    handleMessage(event) {
        if (!event.data)
            return;
        const tipo = event.data.type;
        if (tipo === 'IFRAME_READY' || tipo === 'CLOSE_ENRICHMENT_MODAL') {
            console.log('[IframeModal] handleMessage recebeu:', tipo);
        }
        if (tipo === 'IFRAME_READY') {
            this.clearRetryTimers();
            this.sendInit('IFRAME_READY handshake');
            return;
        }
        if (tipo === 'CLOSE_ENRICHMENT_MODAL') {
            this.close();
        }
    }
    close() {
        this.$emit('close');
    }
    clearRetryTimers() {
        this.retryTimers.forEach(t => clearTimeout(t));
        this.retryTimers = [];
    }
    mounted() {
        console.log('[IframeModal] mounted — registrando listener de mensagens');
        window.addEventListener('message', this.handleMessage);
    }
    beforeDestroy() {
        this.clearRetryTimers();
        window.removeEventListener('message', this.handleMessage);
    }
};
__decorate([
    PropSync('open', { default: false })
], WhatsappEnrichmentIframeModal.prototype, "showModal", void 0);
__decorate([
    Prop({ default: false })
], WhatsappEnrichmentIframeModal.prototype, "termsAccepted", void 0);
WhatsappEnrichmentIframeModal = __decorate([
    Component({ name: 'WhatsappEnrichmentIframeModal' })
], WhatsappEnrichmentIframeModal);
export default WhatsappEnrichmentIframeModal;
